'use client';

import Image from 'next/image';
import { useRouter } from 'next/navigation';
import { isDesktop, isMobile } from 'react-device-detect';
import Button from '@/common/components/button';
import Layout from '@/common/components/layout';

// error page

export default function Error({
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const router = useRouter();

  const handleBack = () => {
    router.replace('/');
  };
  return (
    <Layout
      responsiveAppbar={true}
      appbar={{
        showSearch: isDesktop,
        storeWidget: true,
      }}
    >
      <section className="h-[calc(100vh-64px)] w-screen">
        <div className="flex items-center justify-center w-full h-full">
          <div className="flex flex-col items-center gap-8">
            <Image
              src={
                'https://s3.ir-thr-at1.arvanstorage.ir/witrocdn/static/images/webp/error.webp'
              }
              alt="Error"
              width={260}
              height={300}
              className="h-full max-h-[184px] w-full max-w-[160px] lg:max-h-[300px] lg:max-w-[260px]"
            />
            <div className="max-w-[320px] text-justify text-sm text-secondary-300 lg:max-w-[449px]  lg:text-lg">
              <p>
                یه مشکلی پیش اومده! زودتر از این که این پیام رو بخونین، تیم فنی
                رفته سراغ راه حل. در صورت نیاز می‌تونین با پشتیبانی ویترو در
                ارتباط باشین.
              </p>
            </div>
            <div className="fixed bottom-[calc(4.5rem+env(safe-area-inset-bottom))] z-[70] flex w-full items-center gap-6 px-4 lg:static lg:bottom-[unset] lg:z-auto lg:w-fit lg:px-0">
              <Button
                onClick={reset}
                className="w-full lg:w-fit"
                type={isMobile ? 'outline' : 'link'}
              >
                تلاش مجدد
              </Button>
              <Button
                onClick={handleBack}
                className="w-full lg:w-fit"
                type={isMobile ? 'black' : 'link'}
              >
                {isMobile ? 'بازگشت' : 'بازگشت به صفحه اصلی'}
              </Button>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}
